var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownPesoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ArrowDownPesoMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.762 6.123h.01c.41.88.26 1.93-.38 2.67l-5.512 6.35c-.47.55-1.16.86-1.881.86-.72 0-1.41-.31-1.88-.86L.617 8.793a2.482 2.482 0 01-.39-2.67c.41-.89 1.3-1.46 2.27-1.46h.5v-2.16c0-1.38 1.11-2.5 2.492-2.5h5.01a2.499 2.499 0 012.492 2.5v2.16h.5c.97 0 1.87.57 2.27 1.46zm-1.9 1.36h-.02c.28-.32.05-.82-.371-.82h-2.01a.5.5 0 01-.49-.5v-3.67c0-.28-.221-.5-.491-.5H5.469a.5.5 0 00-.491.5v3.67c0 .28-.22.5-.49.5H2.477c-.42 0-.65.5-.37.82l5.512 6.35c.1.11.24.17.37.17s.27-.06.37-.17l5.503-6.35zM8.8 6.853h.01c.8.16 1.37.87 1.34 1.7-.07.92-.81 1.65-1.71 1.72v.27c.02.3-.22.58-.541.6h-.07c-.33 0-.6-.26-.61-.59v-.35c-.66-.17-1.18-.69-1.34-1.36-.13-.7.22-.88.38-.93.32-.1.75.07.86.34l.04.11c.17.43.35.78.93.67.32-.06.53-.19.58-.36.03-.12-.02-.26-.15-.38a1.9 1.9 0 00-.62-.22c-.66-.17-1.54-.39-1.83-1.1-.17-.4-.17-.84 0-1.24.16-.4.48-.71.88-.87.08-.03.17-.06.26-.08v-.35c0-.32.26-.57.57-.57h.03c.32 0 .58.25.6.56v.31c.66.06 1.23.52 1.43 1.16.1.38.02.61-.06.73a.5.5 0 01-.29.21c-.16.07-.32.07-.48.02a.634.634 0 01-.37-.33.3.3 0 01-.04-.1.737.737 0 00-.92-.49c-.04.01-.12.06-.12.06h-.04c-.13.02-.22.16-.19.29.02.06.06.12.11.15.23.11.49.2.75.25.22.05.43.11.61.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPesoMini);
export default __webpack_public_path__ + "static/media/ArrowDownPesoMini.d70887461aa396731d556d91fc142872.svg";
export { ForwardRef as ReactComponent };